module.exports = __webpack_public_path__ + "static/the-road-of-lost-innocence-ddb7436fe2f39cc759d40501647f7a14.jpg";